import { useTranslation } from "react-i18next";
import { IoChevronDown } from "react-icons/io5";

export const LanguageSwitcher = ({ onLanguageChange }) => {
    const { i18n } = useTranslation();

    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
        if (onLanguageChange) {
            onLanguageChange(lang);
        }
    };

    return (
        <div className="relative group">

            <button className="flex items-center gap-2 px-3 py-2 text-gray-900 hover:text-clickable rounded md:p-0 text-lg font-medium uppercase border-2 border-gray-300 md:border-0 hover:border-clickable md:hover:border-0 transition-all">
                {i18n.language.toUpperCase()}
                <IoChevronDown className="transition-transform group-hover:rotate-180" />
            </button>

            <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <button onClick={() => handleLanguageChange("nl")} className={`block w-full text-left px-4 py-2 text-lg hover:bg-gray-100 rounded-b-lg transition-colors ${i18n.language === "nl" ? "bg-gray-100 font-bold text-clickable" : "text-gray-900"}`}>
                    Nederlands
                </button>

                <button onClick={() => handleLanguageChange("en")} className={`block w-full text-left px-4 py-2 text-lg hover:bg-gray-100 rounded-t-lg transition-colors ${i18n.language === "en" ? "bg-gray-100 font-bold text-clickable" : "text-gray-900"}`}>
                    English
                </button>
            </div>
        </div>
    );
};